import { render, staticRenderFns } from "./legajoVirtual.vue?vue&type=template&id=de6b557c&scoped=true"
import script from "./legajoVirtual.vue?vue&type=script&lang=js"
export * from "./legajoVirtual.vue?vue&type=script&lang=js"
import style0 from "./legajoVirtual.vue?vue&type=style&index=0&id=de6b557c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6b557c",
  null
  
)

export default component.exports